import React from 'react';
import { Link } from 'react-router-dom';
import { H1, Body, Card } from '../components/ui';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import DataExportCard from '../components/settings/DataExportCard';
import { CurrencyDollarIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

const Settings: React.FC = () => {
  const { user } = useAuth();
  const { mode, setMode } = useTheme();

  return (
    <div className="max-w-3xl mx-auto">
      <H1 className="mb-2">Settings</H1>
      <Body className="text-gray-600 dark:text-gray-400 mb-8">Manage your account preferences.</Body>

      <Card className="p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Profile</h3>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-500 dark:text-gray-400">Name</span>
            <span className="text-gray-900 dark:text-gray-100">{user?.first_name} {user?.last_name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500 dark:text-gray-400">Username</span>
            <span className="text-gray-900 dark:text-gray-100">{user?.username}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500 dark:text-gray-400">Email</span>
            <span className="text-gray-900 dark:text-gray-100">{user?.email}</span>
          </div>
        </div>
      </Card>

      <Card className="p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Appearance</h3>
        <div className="flex items-center justify-between">
          <span className="text-gray-500 dark:text-gray-400">Theme</span>
          <select
            value={mode}
            onChange={(e) => setMode(e.target.value as 'light' | 'dark' | 'system')}
            className="px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          >
            <option value="light">Light</option>
            <option value="dark">Dark</option>
            <option value="system">System</option>
          </select>
        </div>
      </Card>

      <DataExportCard />

      <Link
        to="/settings/billing"
        className="block mt-6 p-6 rounded-xl border border-gray-200 dark:border-gray-700 hover:border-primary-300 dark:hover:border-primary-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center">
            <CurrencyDollarIcon className="w-5 h-5 text-primary-600 dark:text-primary-300" />
          </div>
          <div className="flex-1">
            <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Billing</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
              See your current plan and a preview of what this cycle would cost.
            </p>
          </div>
          <ArrowRightIcon className="w-5 h-5 text-gray-400" />
        </div>
      </Link>
    </div>
  );
};

export default Settings;
